import { useSelector } from 'react-redux';
import moment from 'moment';

const useDate = () => {
  const { Time_Setting } = useSelector((state) => state.app?.appConfigs) || {};
  const formatDate = (date) => {
    if (!date) {
      return null;
    }

    if (!date._isAMomentObject) {
      date = moment(date);
    }

    return Time_Setting?.Default_Time_Format
      ? date.format(Time_Setting?.Default_Time_Format)
      : date.format('MM-DD-YYYY');
  };

  return {
    formatDate,
  };
};

export default useDate;
